<template>
  <div class="p-16">
    <div class="top">
      <div class="often" :class="activeData==='often'?'active':''" @click="changeIndex('often')">
        <div>
          <img :src="require('@/assets/evaluation/yuan.png')" alt />
          <span>常用指标</span>
        </div>
      </div>
      <div class="all" :class="activeData==='all'?'active1':''" @click="changeIndex('all')">
        <div>
           <img :src="require('@/assets/evaluation/fang.png')" alt />
          <span>全部指标</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div v-show="list.length > 0"  v-for="(item, index) in list" :key="index" class="last">
        <div class="title"> 
          <van-checkbox @click="checkAll(item)" v-model="item.Checked" style="margin-right:29px;">{{item.IndexManagementName}}</van-checkbox>
        </div>
        <ul class="ul" v-if="item.Childrens.length>0">
          <li v-for="(pros,index1) in item.Childrens" :key="index1">
              <van-checkbox @click="ischeck(item,pros)" v-model="pros.Checked" >
              </van-checkbox>
              <div style="width:80%;">
                <p style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{pros.IndexManagementName}}</p>
                <van-rate  v-if="pros.SocringMethod===1" v-model="pros.DefaultValue" color="#FFBE32" :size="20" />
                <div v-if="pros.SocringMethod===0" class="min-max">
                  <span>{{pros.MinValue}}分</span>
                  <van-slider bar-height="4px" :min="pros.MinValue" :max="pros.MaxValue" v-model="pros.DefaultValue" active-color="#4196FF">
                    <template #button>
                      <div class="custom-button"> 
                        {{ pros.DefaultValue }}
                      </div>
                    </template>
                  </van-slider>
                  <span>{{pros.MaxValue}}分</span>
                </div>
              </div>
          </li>
        </ul>
        <ul class="ul" v-else>
          <div style="padding:10px 35px;">
            <van-rate v-if="item.SocringMethod===1" v-model="item.DefaultValue" color="#FFBE32" :size="20" />
            <div v-if="pros.SocringMethod===0" class="min-max">
              <span>{{pros.MinValue}}分</span>
              <van-slider bar-height="4px" :min="pros.MinValue" :max="pros.MaxValue" v-model="pros.DefaultValue" active-color="#4196FF">
                <template #button>
                  <div class="custom-button"> 
                    {{ pros.DefaultValue }}
                  </div>
                </template>
              </van-slider>
              <span>{{pros.MaxValue}}分</span>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <div class="sigle-bottom-btn">
        <van-button type="info" round @click="checkPerson">选择学生</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value:1,
      activeData:'often',
      result:[],
      Scores:[],
      obj:{},
      list: []
  }
  },
  created(){
    this.obj = this.$store.state.evaluation.averageObj
    this.fetchCommUsedList()
  },
  methods:{
    // 获取常用指标列表
    async fetchCommUsedList(){
        this.xy.loading()
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetStudentCommonIndex`, {
          schoolDistrictID: this.obj.SchoolDistrictID,
          academicSessionID: this.obj.AcademicSessionID,
          academicYearID: this.obj.AcademicYearID,
          studentGradeForStudentYearID: this.obj.StudentGradeForStudentYearID,
          disciplineID: this.obj.DisciplineID
        })
        this.xy.unloading()
        if (res.success) {
          this.list=[]
          if (res.data.length > 0) {
            this.list=res.data
            console.log("常用指标",res.data)
          }
        }
    },
    // 获取全部指标列表
    async fetchAllList(){
      this.xy.loading()
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetAllIndex`, {
        schoolDistrictID: this.obj.SchoolDistrictID,
        academicSessionID: this.obj.AcademicSessionID,
        academicYearID: this.obj.AcademicYearID,
        studentGradeForStudentYearID: this.obj.StudentGradeForStudentYearID,
        disciplineID: this.obj.DisciplineID
      })
      this.xy.unloading()
      if (res.success) {
        this.list=[]
        if (res.data.length > 0) {
          this.list=res.data
          console.log("全部指标",res.data)
        }
      }
    },
    // 选中单个指标
    ischeck (item, pro) {
      if(pro.Checked){
        let arr=[]//选中的数量
        item.Childrens.forEach(v=>{
          if(v.Checked){
            arr.push(v.IndexManagementID)
          }
        })
        if(arr.length === item.Childrens.length){
          item.Checked=true
        }
      }else{
        item.Checked=false
      }
    },
    // 选中小组
    checkAll (item) {
      item.Childrens.forEach(pro => {
        pro.Checked = item.Checked
      })
      console.log("item.Childrens",item.Childrens)
    },
    // 去选择学生页面
    checkPerson(){
       // 获取选中指标id和设置的值
      this.Scores=[]
      this.list.forEach(item=>{
        if(item.Checked){
          if(item.Childrens.length ===0){
            this.Scores.push({ IndexManagementID: item.IndexManagementID, Value: item.DefaultValue })
          }else{
            item.Childrens.forEach(item1=>{
              if(item1.Checked){
                this.Scores.push({ IndexManagementID: item1.IndexManagementID, Value: item1.DefaultValue })
              }
            })
          }
        }else{
          if(item.Childrens.length !==0){
            item.Childrens.forEach(item1=>{
              if(item1.Checked){
                this.Scores.push({ IndexManagementID: item1.IndexManagementID, Value: item1.DefaultValue })
              }
            })
          }
        }
      })
      // console.log("传的设置的值",this.Scores)
      if(this.Scores.length>0){
        this.$router.push({ path: '/home/choiceStudent',query:{Scores: this.Scores}});
      }else{
         this.xy.msgInfo('请选择指标并打分')
      }
    },
    // 改变指标
   changeIndex(data){
     this.activeData=data
     if(data==="all"){
       this.fetchAllList()
     }else if(data==="often"){
       this.fetchCommUsedList()
     }
   },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    }
  }
}
</script>  
<style lang="less" scoped>
  /deep/ .van-checkbox__label{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .p-16{
    margin-top:20px;
    padding:20px 16px; 
    background: #fff;
  }
  /deep/ .van-slider{
    width:70%;
  }
  .min-max{
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
      color:#999999;
    }
  }
 .custom-button {
    width: 45px;
    color: #fff;
    font-size: 10px;
    line-height: 28px;
    text-align: center;
    background-color: #4196FF;
    border-radius: 100px;
  }
.top{
  padding-bottom:30px;
  >div{
    display: inline-block;
    width: 208px;
    height: 94px;
    line-height: 94px;
    border-radius: 8px;
    img{
      width:34px;
      height: 34px;
      margin-right:15px;
    }
  }
}
.often{
  margin-right:26px;
  background:#FCF4E9 ;
  box-sizing: border-box;
  &>div{
    display: flex;
    justify-content: center;
    align-items: center;
    &>span{
     color: #000000;
     font-size: 28px;
     font-weight: 700;
    }
  }
}
.active{
  border: 2px solid #FF7623;
  span{
   color: #FF7623 !important;
  }
}
.all{
  background:#EDF6FF ;
  box-sizing: border-box;
  &>div{
    display: flex;
    justify-content: center;
    align-items: center;
    &>span{
     color: #000000;
     font-size: 28px;
     font-weight: 700;
    }
  }
}
.active1{
  border: 2px solid #4196FF;
  span{
   color: #4196FF !important;
  }
}
.bottom{
  margin-bottom:50px;
  .title{
    padding:0 14px;
    background: #F5F5F5;
    color:#333333;
    /deep/ .van-checkbox{
      height: 80px;
      line-height: 80px;
    }
  }

  .last:last-child{
    li:last-child{
      margin-bottom:100px;
    }
  }
  
  .ul{
    padding:22px 0;
    li{
      display: flex;
      align-items: center;
      height: 130px;
      border-bottom: 1px solid #EBEBEB;
      padding:11px 15px;
      /deep/ .van-checkbox{
        display: inline-block;
        margin-right:24px;
        height:50px;
      }
      /deep/ .van-slider{
        height: 3px;
      }
      p{
        margin-bottom:30px;
      }
    }
  }
}
.sigle-bottom-btn {
  height: 110px;
  line-height: 110px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  button {
    flex: 1;
    margin: 17px 30px;
  }
}

</style>